import { Box, Button, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { GenericAccordion } from '../SettingsUI';
import type { SubjectItem } from '../../types';

interface SubjectsPanelProps {
  subjects: SubjectItem[];
  openModal: () => void;
}

export function SubjectsPanel({ subjects, openModal }: SubjectsPanelProps) {
  return (
    <GenericAccordion
      title={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography fontSize={12} fontWeight={700} color="white">
            Subjects
          </Typography>
          <Button
            disableRipple
            onClick={(e) => {
              e.stopPropagation();
              openModal();
            }}
            sx={{
              textTransform: 'none',
              borderRadius: '6px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              fontFamily: 'Inter, sans-serif',
              color: '#F79420',
              fontSize: 12,
              fontWeight: 600,
              px: 1,
              py: 0.5,
              '&:hover': { background: 'rgba(247, 148, 32, 0.08)' }
            }}
          >
            Add Subject
            <AddIcon sx={{ fontSize: 20, color: '#F79420' }} />
          </Button>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, pt: 1 }}>
        {subjects.length === 0 && (
          <Typography fontSize={12} color="#868686">
            No subjects added yet.
          </Typography>
        )}
        {subjects.map((s, i) => (
          <Box
            key={i}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 1,
              borderRadius: 1,
              background: 'rgba(0,0,0,0.7)',
              outline: '1px solid #2A2A2A'
            }}
          >
            <Typography sx={{ color: '#fff', fontSize: 13 }}>{s.name}</Typography>
            <Box
              sx={{
                px: 1,
                py: 0.2,
                borderRadius: 1,
                background: s.type === 'topic' ? '#F7942033' : '#20A4F733',
                color: '#fff',
                fontSize: 11,
                textTransform: 'capitalize'
              }}
            >
              {s.type}
            </Box>
          </Box>
        ))}
      </Box>
    </GenericAccordion>
  );
}
